import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { environment } from 'src/environments/environment';
import { VideoModalComponent } from '../modals/video-modal.component';
import { CalendlyUrls } from './consulting.constants';

@Component({
  selector: 'app-consulting',
  templateUrl: './consulting.component.html',
  styleUrls: ['./consulting.component.scss'],
})
export class ConsultingComponent {
  @Input() productId: string;
  @Input() video = false;

  constructor(
    private translateService: TranslateService,
    protected readonly modals: NgbModal
  ) {}

  openVideoModal() {
    const ref = this.modals.open(VideoModalComponent, {
      backdrop: true,
      keyboard: false,
      windowClass: 'basic-video-modal',

      backdropClass: 'basic-modal-backdrop',
    });

    ref.componentInstance.videoId = 'aYsa2f1fy5s';
    ref.componentInstance.forceCC = true;
  }

  getUrl(): string {
    const lang = this.translateService.currentLang;

    switch (this.productId) {
      case environment.products.dietAndBodyWeight:
      case environment.products.dietAndNutrition:
      case environment.products.vitaminsAndMinerals:
      case environment.products.metabolismAndLifeStyle:
      case environment.products.dietAndBodyWeightOLD:
      case environment.products.vitaminsAndMineralsOLD:
      case environment.products.metabolismAndLifeStyleOLD:
        return CalendlyUrls[lang]?.nutrition;
      case 'DNA':
      case environment.products.heartHealthDna:
      case environment.products.skinHealthAndAgeing:
      case environment.products.mindAndWellbeing:
      case environment.products.bodyAndMind:
      case environment.products.immuneSystem:
      case environment.products.heartHealthDnaOLD:
      case environment.products.skinHealthAndAgeingOLD:
        return CalendlyUrls[lang]?.consultations;
      case environment.products.sportsPerformance:
      case environment.products.sportAndRecreation:
      case environment.products.sportsPerformanceOLD:
        return CalendlyUrls[lang]?.sports;
      default:
        return '';
    }
  }

  book() {
    const url = this.getUrl();
    if (url) {
      window.open(url, '_blank');
    }
  }
}
